import i18n from '@/libs/i18n'

export default [
  // *===============================================---*
  // *--------- QUESTION ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/questions/list',
    name: 'pages-questions-list',
    component: () => import('@/views/pages/question/QuestionList.vue'),
    meta: {
      resource: 'question',
      action: 'read',
      breadcrumb: [
        {
          text: i18n.t('general.list'),
          active: false,
        },
      ],
      pageTitle: i18n.t('questions.mainVerticalMenu.questions'),
    },
  },
  {
    path: '/questions/add',
    name: 'pages-questions-add',
    component: () => import('@/views/pages/question/QuestionAdd.vue'),
    meta: {
      resource: 'question',
      action: 'create',
      breadcrumb: [
        {
          text: i18n.t('general.add'),
          active: false,
        },
      ],
      pageTitle: i18n.t('questions.mainVerticalMenu.questions'),
    },
  },
  {
    path: '/questions/edit/:id',
    name: 'pages-questions-edit',
    component: () => import('@/views/pages/question/QuestionEdit.vue'),
    meta: {
      resource: 'question',
      action: 'update',
      breadcrumb: [
        {
          text: i18n.t('general.edit'),
          active: false,
        },
      ],
      pageTitle: i18n.t('questions.mainVerticalMenu.questions'),
    },
  },
]
